import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from '../service/utility.service';

@Component({
  selector: 'app-myths',
  templateUrl: './myths.page.html',
  styleUrls: ['./myths.page.scss'],
})
export class MythsPage implements OnInit {

  data : any = []

  constructor(private http: HttpClient,
              private utlity : UtilityService) { }

  ngOnInit() {
    this.fetchMyths();
  }
   
  fetchMyths() {
    return new Promise((resolve, reject) => {
      this.http.get("assets/mythData.json").subscribe(res => {
        this.data = res;
      })
      });
  }

info() {
  this.utlity.goInfoTab();
}
zoomImage() {
}
changeSource(event) { event.target.src = 'https://www.who.int/images/default-source/wpro/coronavirus-2.jpg?sfvrsn=f3ceff40_17'; }

}
